import css from './graph.module.scss';

import { memo } from 'react';

import { TTimeRecord } from '../types';
import { TXY } from './type';

const Curve = ({ xy, dataSorted }: { xy: TXY; dataSorted: TTimeRecord[] }) => (
  <g data-role="curve">
    <polyline
      points={dataSorted.map(item => xy(item.weeks, item.count)).join(' ')}
      className={css.curve}
    />
  </g>
);

export default memo(Curve);
